import React from "react";
import "../styles/CardProject.scss";

//import img from "../img/proyecto_01.jpg";
//import img from "../img/";

const CardProject = ({
	name,
	description,
	collaborators,
	linkProyect,
	linkCode,
	tech,
	src,
}) => {
	console.log();
	return (
		<div className="card">
			<div className="lines"></div>
			<div className="container-img">
				{/* <img src={src} alt="Imagen" /> */}
				<div className="img" style={{ backgroundImage: `url(${src})` }}></div>
			</div>
			<p className="name">{name}</p>
			<p className="description">{description}</p>
			<p className="tech">{tech}</p>

			{collaborators ? (
				<>
					<p>Integrantes:</p>
					<div className="collaborators"> {collaborators} </div>
				</>
			) : null}
			<div className="container-links">
				{linkCode ? (
					<a
						className="link link-code"
						href={linkCode}
						target="_blank"
						rel="noreferrer"
					>
						Código
					</a>
				) : null}
				{linkProyect ? (
					<a
						className="link link-proyect"
						href={linkProyect}
						target="_blank"
						rel="noreferrer"
					>
						Proyecto
					</a>
				) : null}
			</div>
		</div>
	);
};

export default CardProject;
